import { render, staticRenderFns } from "./quotientTestResults.vue?vue&type=template&id=16373e7c&scoped=true"
import script from "./quotientTestResults.vue?vue&type=script&lang=js"
export * from "./quotientTestResults.vue?vue&type=script&lang=js"
import style0 from "./quotientTestResults.vue?vue&type=style&index=0&id=16373e7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16373e7c",
  null
  
)

export default component.exports